<template>
  <div class="fivth-Bar">
    <router-link
      :to="$i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })"
      v-for="(item, index) in list"
      :key="item.id"
      class="card"
      :style="`grid-area: card-${index + 1}`"
    >
      <div class="image-block">
        <ImageContainer
          :src="item.image.medium"
          :alt="item.title"
          :thumb="item.image.thumbnail"
          class="image"
        />
      </div>

      <div class="about">
        <span class="category">{{ item.sub_category.name }}</span>
        <h1 class="text">
          {{ item.title }}
        </h1>
        <h2 class="time">
          {{ handleDate(item.pub_date) }}, {{ handleTime(item.pub_date) }}
        </h2>
      </div>
    </router-link>
  </div>
</template>
<script>
import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";
export default {
  name: "FivthBar",
  components: {
    ImageContainer
  },
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  setup() {
    return {
      ...useFormatter()
    };
  }
};
</script>
<style lang="scss" scoped>
.fivth-Bar {
  padding-top: 5rem;
  padding-bottom: 4rem;
  width: 98%;
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr 39%;
  grid-template-areas:
    "card-2 card-3 card-1"
    "card-4 card-5 card-1";
  grid-gap: 2.1em 2.5em;
  margin-left: auto;
  .card {
    position: relative;
    display: flex;
    flex-direction: row-reverse;
    .image-block {
      position: relative;
      .image {
        position: relative;
      }
    }
    .about {
      position: relative;
      font-style: normal;
      margin-right: 0.6rem;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      text-align: end;
      .category {
        position: relative;
        font-family: Open Sans;
        font-style: normal;
        font-weight: 600;
        font-size: 2em;
        text-align: center;
        opacity: 0.7;
        text-transform: uppercase;
        margin-top: 0.4rem;
      }
      .text {
        position: relative;
        font-family: Roboto;
        font-weight: 500;
        font-size: 2.2em;
        display: -webkit-box;
        -webkit-line-clamp: var(--snup);
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
      .time {
        position: relative;
        font-family: Open Sans;
        font-weight: 300;
        font-size: 2em;
        opacity: 0.8;
      }
    }
    &:nth-child(1) {
      align-items: center;
      background: #fff;
      border-radius: 8.8em 0 0 0;
      color: #121212;
      .image-block {
        // max-width: 327px;
        margin: 2rem 1rem 2rem 0;
        width: 51%;
        .image {
          border-radius: 7.65em 0 0 0;
          aspect-ratio: 327/244;
        }
      }
      .about {
        width: 40%;
        line-height: 1.3;
        .text {
          margin: 0.3rem 0 0.5rem 0;
          --snup: 3;
        }
      }
    }
    &:nth-child(2),
    &:nth-child(3),
    &:nth-child(4),
    &:nth-child(5) {
      color: #fff;
      .image-block {
        width: 40%;
        // max-width: 181px;
        .image {
          aspect-ratio: 181/136;
        }
      }
      .about {
        line-height: 1.2;
        width: 60%;
        .text {
          --snup: 3;
        }
        .time {
          display: block;
          margin-top: auto;
        }
      }
    }
    &:nth-child(2),
    &:nth-child(5) {
      .image-block {
        .image {
          border-radius: 4.3em 0;
        }
      }
    }
    &:nth-child(3),
    &:nth-child(4) {
      .image-block {
        .image {
          border-radius: 0 4.3em;
        }
      }
    }
  }
}
@media screen and (max-width: 2900px) {
  .fivth-Bar {
    width: 95%;
    .card {
      .about {
        .category {
          font-size: 1.2em;
        }
        .text {
          font-size: 1.5em;
        }
        .time {
          font-size: 1.2em;
        }
      }
    }
  }
}
@media screen and (max-width: 1920px) {
  .fivth-Bar {
    width: 90%;
    .card {
      .about {
        .category {
          font-size: 1em;
        }
        .text {
          font-size: 1.19em;
        }
        .time {
          font-size: 0.88em;
        }
      }
      &:nth-child(1) {
        .image-block {
          max-width: 327px;
        }
      }
      &:nth-child(2),
      &:nth-child(3),
      &:nth-child(4),
      &:nth-child(5) {
        .image-block {
          max-width: 181px;
        }
      }
    }
  }
}

@media screen and (max-width: 998px) {
  .fivth-Bar {
    top: -15.5em;
    padding-top: 0;
    // background-color: #60657d;
    width: 100%;
    grid-template-columns: repeat(5, 1fr);
    grid-template-areas:
      ". . . card-5 card-5"
      ". . . card-5 card-5"
      "card-2 card-2 . card-5 card-5"
      "card-2 card-2 . card-3 card-3"
      "card-2 card-2 . card-3 card-3"
      "card-4 card-4 . card-3 card-3"
      "card-4 card-4 card-1 card-1 card-1"
      "card-4 card-4 card-1 card-1 card-1";
    grid-gap: 2.25em 1.5em;
    .card {
      .about {
        align-items: center;
        text-align: center;
      }
      &:nth-child(2),
      &:nth-child(3),
      &:nth-child(4),
      &:nth-child(5) {
        flex-direction: column;
        .image-block {
          width: 100%;
          max-width: inherit;
          .image {
            aspect-ratio: 265/199;
          }
        }
        .about {
          width: 100%;
          margin: 0;
          .category {
            margin: 0.8rem 0 0 0;
          }
          .text {
            margin: 0.1rem 0 0.5rem 0;
          }
          .time {
            font-size: 0.9em;
          }
        }
      }
      &:nth-child(1) {
        border-radius: 6.09em 0 0 0;
        .image-block {
          margin: 1rem 1rem 1rem 0;
        }
        .about {
          width: 40%;
          margin-left: 1.5rem;
          .text {
            --snup: 3;
          }
        }
      }
      &:nth-child(3),
      &:nth-child(5) {
        margin-right: 1.2rem;
        .image-block {
          .image {
            border-radius: 0 6.21em;
          }
        }
      }
      &:nth-child(2),
      &:nth-child(4) {
        margin-left: 1.2rem;
        .image-block {
          .image {
            border-radius: 6.21em 0;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 775px) {
  .fivth-Bar {
    top: -11em;
    .card {
      &:nth-child(2),
      &:nth-child(3),
      &:nth-child(4),
      &:nth-child(5) {
        max-width: 265px;
      }
    }
  }
}
@media screen and (max-width: 475px) {
  .fivth-Bar {
    background: none;
    top: 0;
    padding-top: 1rem;
    grid-template-columns: 1fr 1fr;
    grid-gap: 1.5em 0;
    grid-template-areas:
      "card-2 card-3 "
      "card-2 card-3 "
      "card-2 card-3 "
      "card-1 card-1 "
      "card-1 card-1 "
      "card-4 card-5 "
      "card-4 card-5 ";
    .card {
      .about {
        .category {
          font-size: 0.9em;
        }
        .text {
          font-size: 1em;
        }
        .time {
          font-size: 0.8em !important;
        }
      }
      &:nth-child(1) {
        width: 98%;
        background: none;
        flex-direction: column;
        border-radius: 8.5em;
        overflow: hidden;
        margin: 0;
        justify-self: center;
        color: #fff;
        .image-block {
          max-width: 100%;
          width: 100%;
          margin: 0;
          .image {
            border-radius: 8.5em;
            aspect-ratio: 363/272;
          }
        }
        .about {
          box-sizing: border-box;
          width: 100%;
          position: absolute;
          bottom: 0;
          padding: 0 2.5rem;
          background: #56596f;
          opacity: 0.8;
          //   border-radius: 0 0 8.5em 8.5em;
          .text {
            margin-top: 0;
            --snup: 2;
          }
          .time {
            margin-bottom: 0.5rem;
          }
        }
      }
      &:nth-child(2),
      &:nth-child(3),
      &:nth-child(4),
      &:nth-child(5) {
        margin: 0;
        .image-block {
          border-radius: inherit;
          .image {
            border-radius: inherit;
          }
        }
        .about {
          justify-self: center;
          .text {
            --snup: 3;
          }
        }
      }
      &:nth-child(2),
      &:nth-child(5) {
        max-width: 165px;
        z-index: 10;
        .image-block {
          border-radius: 13.56em;
          aspect-ratio: 165/130;
          .image {
            border-radius: 13.56em;
            aspect-ratio: 165/130;
          }
        }
      }
      &:nth-child(5) {
        justify-self: end;
      }
      &:nth-child(3),
      &:nth-child(4) {
        width: 105%;
        max-width: 195px;
        justify-self: end;
        .image-block {
          width: 100%;
          background: #4b4d61;
          display: flex;
          aspect-ratio: 195/130;
          align-items: center;
          .image {
            width: 85%;
            aspect-ratio: 159/120;
            max-width: 159px;
          }
        }
        .about {
          width: 90%;
        }
      }
      &:nth-child(3) {
        justify-self: end;
        .image-block {
          justify-content: start;
          border-radius: 13.5em 0 0 13.5em;
          .image {
            border-radius: 13.5em 0 0 13.5em;
            margin-left: auto;
          }
        }
        .about {
          margin: 0 0 0 auto;
        }
      }
      &:nth-child(4) {
        justify-self: start;
        .image-block {
          border-radius: 0 13.5em 13.5em 0;
          justify-content: end;
          .image {
            border-radius: 0 13.5em 13.5em 0;
            margin-right: auto;
          }
        }
        .about {
          margin: 0 auto 0 0;
        }
      }
    }
  }
}
</style>
